<template>
  <p>
    Очень многое зависит от построения самого текста песни, общие рекомендации:
  </p>
  <ul>
    <li>
      В зависимости от стиля трека нужно подбирать настроение с которым исполнитель будет пропевать слова. К примеру: sad, minor, angry и так далее (больше примеров настроения в методичке).
      В самом тексте это будет выглядеть примерно так:
      [Verse, sad, minor] (Текст куплета который будет исполняться именно в этом настроении)
    </li>
    <li>
      Необходимо каждый куплет, припев, начало, завершение в треке обозначать и разграничивать.
    </li>
    <li>
      Перед куплетом необходимо писать [Verse]
    </li>
    <li>
      Перед припевом необходимо писать [Chorus]
    </li>
    <li>
      Перед началом трека, для плавного и гармоничного вступления необходимо писать [Intro]
    </li>
    <li>
      Перед завершением трека, для того чтобы его не обрезало, необходимо писать [Outro]
    </li>
  </ul>
  <p>
    Методичка: <a target="_blank" href="/assets/Suno_Udio_StableAudio. Владислав Эль.pdf">Suno_Udio_StableAudio. Владислав Эль</a>
  </p>
</template>

<script setup>
</script>
